const colors = {
  primary: "#1F332F",
  secondary: "#FF590D",
  white: "#FFFFFF",
  ice: "#E1E7EB",
  blue: "#1239FF",
  cherry: "#FF590D",
  kelp: "#1F332F",
  poppy: "#FF590D",
  plush: "#FFE5D9",
  foam: "#CFE6DF",
  grape: "#FF8971",
  yellow: "#FFFF00",
  green: "#59993D",
  teal: "#24AEC3",
  tealDark: "#27869C",
  gray: "#ececec",
}

export { colors }
